export default (function (value) {
  return value === null;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/isNull.js
// module id = 1451
// module chunks = 1